import { PBApiProduct } from "../ProductsApiContext";

export default function getBrokerDataFromProduct(product: PBApiProduct, brokerId: string) {
  if (!product || !product.brokers) {
    throw new Error('Product or brokers data is missing');
  }

  const broker = product?.brokers?.find((b) => b?.[brokerId]?.id === brokerId)?.[brokerId];

  if (!broker) {
    throw new Error(`Broker with ID ${brokerId} not found in product`);
  }

  return broker;
}